var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import QRCode from "qrcode.react";
import { injectIntl } from "@irati/utils/lang";
import StockType from "@irati/stock/enums/StockType";
import ValueLabel from "./ValueLabel";
import { ProductCode, CodeWrapper, QRCodeWrapper, StyledLink } from "./styled";
var Code = /** @class */ (function (_super) {
    __extends(Code, _super);
    function Code() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Code.prototype.render = function () {
        var _a = this.props, redemption = _a.redemption, formatMessage = _a.formatMessage;
        if (!redemption || !redemption.stock)
            return null;
        switch (redemption.stock.type) {
            case StockType.QR:
                return (React.createElement(QRCodeWrapper, null,
                    React.createElement(QRCode, { value: redemption.stock.code, size: 240 })));
            case StockType.URL:
                return (React.createElement(CodeWrapper, null,
                    React.createElement(ValueLabel, { label: formatMessage({ id: "recognition.account.rewards.url" }) }),
                    React.createElement(StyledLink, { href: redemption.stock.code, target: "_blank" }, redemption.stock.code)));
            default:
                return (React.createElement(CodeWrapper, null,
                    React.createElement(ValueLabel, { label: formatMessage({ id: "recognition.account.rewards.discountCode" }) }),
                    React.createElement(ProductCode, null, redemption.stock.code)));
        }
    };
    Code.defaultProps = {
        redemption: undefined
    };
    return Code;
}(PureComponent));
export default injectIntl(Code);
